import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { MonitoringPageService } from './monitoring-page.service';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames } from '../../../../common/constants/icon-names';
import { AutoUnsubscribe } from '../../../../common';
import { SvgIconFacade } from '../../../../store/state/svg-icon';
import { IntrackFeatureModule } from '../../../../intrack-feature.module';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-monitoring-page',
  templateUrl: './monitoring-page.component.html',
  styleUrls: ['./monitoring-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IntrackFeatureModule, TranslateModule, SvgIconComponent],
})
@AutoUnsubscribe
export class MonitoringPageComponent implements AfterViewInit, OnInit {
  @Input() resizeBreakpoint = 1280;
  @Input() filtersHiddenByDefault = false;
  @Input() showFilterBtnLabel = false;
  @Input() showIcon = true;
  @Input() filtersCount = 0;
  @Input() isFullPage? = true;
  @Input() noIndents = false;

  window = window;
  subscriptions: Subscription[] = [];
  iconNameList = IconNames;
  svgPath = 'assets/core/icons/checkmark.svg';

  @ViewChild('drawer') drawer: MatDrawer;

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: Window & typeof globalThis }): void {
    this.window = event.target;

    if (!this.filtersHiddenByDefault || this.window.innerWidth < this.resizeBreakpoint) {
      this.monitoringPageService.matDrawer$.next(this.drawer);
    }
  }

  constructor(
    public monitoringPageService: MonitoringPageService,
    private cd: ChangeDetectorRef,
    private svgIconFacade: SvgIconFacade,
  ) {}

  ngAfterViewInit(): void {
    this.monitoringPageService.matDrawer$.next(this.drawer);

    this.subscriptions.push(
      this.monitoringPageService.matDrawer$.subscribe(() => {
        this.cd.markForCheck();
      }),
    );
  }

  ngOnInit(): void {
    if (!this.svgIconFacade.getSvgIconMap().has(this.svgPath)) {
      this.svgIconFacade.loadSvgIcon(this.svgPath);
    }
  }
}
